export default function initTito() {
	const $container = document.querySelector("#l-tito-widget-container");
	const $widgetContainer = document.querySelector("#l-tito-widget");
	const $detailsButton = document.querySelector("#l-tito-open-details");
	const $detailsSection = document.querySelector("#l-tito-details");
	const $ticketStep = document.querySelector(".l-tito-ticket-step");
	const $backToTicketsButton = document.querySelector("#l-tito-back-to-tickets");
	const $openPaymentButton = document.querySelector("#l-tito-open-payment");
	const $fullName = document.querySelector("#l-tito-full-name");
	const $email = document.querySelector("#l-tito-email");
	const $phoneNumber = document.querySelector("#l-tito-phone-number");
	const $postcode = document.querySelector("#l-tito-postcode");
	const $accessNotes = document.querySelector("#l-tito-access-notes");
	const $thankYouMessage = document.querySelector("#l-tito-registration-finished");

	if (!$container) {
		return;
	}

	const onWidgetLoaded = () => {
		let ticketEls = document.querySelectorAll(".tito-release");

		if (ticketEls.length > 0) {
			ticketEls = Array.from(ticketEls);
			// For the same reasons as comment on line #8, we need to store JSON as a data attribute -JS
			const data = JSON.parse($container.dataset.titoIntegrationData);

			data.forEach(d => {
				wrapTickets(ticketEls.splice(0, d.count), d);
			});
		}

		if ($ticketStep) {
			$ticketStep.hidden = false;
		}
	};

	if (!window.tito) {
		// Scripts inserted by .innerHTML (Barba.js page transitions) arent parsed, so we need to inject the script ourselves. -JS
		injectTitoScript($container);

		// prettier-ignore
		window.tito = window.tito || function() { (tito.q = tito.q || []).push(arguments); };
	}

	const showRegistrationFinishedState = () => {
		const $ticketGroups = document.querySelectorAll(".tito-group");

		$ticketGroups.forEach($el => {
			$el.hidden = true;
		});

		if ($ticketStep) {
			$ticketStep.hidden = true;
		}

		if ($detailsSection) {
			$detailsSection.hidden = true;
			$detailsSection.classList.remove("is-visible");
		}

		if ($widgetContainer) {
			$widgetContainer.hidden = true;
		}

		if ($thankYouMessage) {
			$thankYouMessage.hidden = false;
		}
	};

	// Protip: This event can be called more than once.
	tito("on:widget:loaded", onWidgetLoaded);
	tito("on:registration:finished", () => {
		showRegistrationFinishedState();
	});

	// The added complexity below is so that we can capture additional customer details that
	// The Unconformity needs. Postcode is the most important, but since we've gone to the effort
	// we can also add other metadata now, like Access note.

	// We have to use the <tito-widget> element because updating the prefill attribute is the only
	// way to pass the data to Tito after the widget has been loaded. If we use the Tito JS API
	// it doesnt provide a way to update the prefill data after the widget has been loaded. -JS
	const $titoElement = document.createElement("tito-widget");
	$titoElement.setAttribute("event", $container.dataset.titoEventId);
	$widgetContainer.appendChild($titoElement);

	const fields = {
		fullName: $fullName,
		email: $email,
		phoneNumber: $phoneNumber,
		postcode: $postcode,
		accessNotes: $accessNotes,
	};

	const updateTitoPrefill = () => {
		const fullName = fields.fullName ? fields.fullName.value.trim() : "";
		const email = fields.email ? fields.email.value.trim() : "";
		const phoneNumber = fields.phoneNumber ? fields.phoneNumber.value.trim() : "";
		const postcode = fields.postcode ? fields.postcode.value.trim() : "";
		const accessNotes = fields.accessNotes ? fields.accessNotes.value.trim() : "";

		const prefill = {
			name: fullName,
			email,
			phone_number: phoneNumber,
			metadata: {},
		};

		if (postcode) {
			prefill.metadata.postcode = postcode;
		}

		if (accessNotes) {
			prefill.metadata.access_notes = accessNotes;
		}

		$titoElement.setAttribute("prefill", JSON.stringify(prefill));
	};

	// The following section sets up the multi-step payment form.
	// Step 1: Choose tickets - a restyled version of the default Tito ticket selection form.
	// Step 2: Capture details - our non-Tito extra metadata fields.
	// Step 3: Pass the data to Tito and open the payment form. Tito handles the rest from here.

	Object.values(fields)
		.filter(field => !!field)
		.forEach(field => {
			field.addEventListener("input", updateTitoPrefill);
			field.addEventListener("change", updateTitoPrefill);
		});

	const requiredFields = [fields.fullName, fields.email, fields.phoneNumber].filter(
		field => !!field
	);

	const getTicketSelectionElements = () => {
		const $ticketGroups = Array.from(document.querySelectorAll(".tito-group"));

		return $ticketGroups.concat($ticketStep || []);
	};

	if ($detailsButton) {
		$detailsButton.addEventListener("click", () => {
			const fadeTargets = getTicketSelectionElements();

			fadeTargets.forEach($el => $el.classList.add("is-fading-out"));

			window.setTimeout(() => {
				fadeTargets.forEach($el => {
					$el.hidden = true;
				});

				if ($detailsSection) {
					$detailsSection.hidden = false;

					window.requestAnimationFrame(() => {
						$detailsSection.classList.add("is-visible");

						if (fields.fullName) {
							fields.fullName.focus();
						}
					});
				}
			}, 260);
		});
	}

	if ($backToTicketsButton) {
		$backToTicketsButton.addEventListener("click", () => {
			const $ticketSelectionElements = getTicketSelectionElements();

			if ($detailsSection) {
				$detailsSection.classList.remove("is-visible");
				$detailsSection.hidden = true;
			}

			$ticketSelectionElements.forEach($el => {
				$el.hidden = false;
			});

			window.requestAnimationFrame(() => {
				$ticketSelectionElements.forEach($el => {
					$el.classList.remove("is-fading-out");
				});
			});

			if ($detailsButton) {
				$detailsButton.focus();
			}
		});
	}

	if ($openPaymentButton) {
		$openPaymentButton.addEventListener("click", () => {
			const invalidField = requiredFields.find(field => !field.checkValidity());

			if (invalidField) {
				invalidField.reportValidity();
				invalidField.focus();
				return;
			}

			updateTitoPrefill();

			const $titoSubmit = $container.querySelector(".tito-submit");

			if ($titoSubmit) {
				$titoSubmit.click();
			}
		});
	}
}

function injectTitoScript($container) {
	const script = document.createElement("script");
	script.type = "text/javascript";
	script.async = true;
	const params = new URLSearchParams(window.location.search);
	const testMode = params.has('TESTMODE');

	let src = "https://js.tito.io/v2/with/inline,facebook";
	if (testMode) {
		src += ",test_mode";
	}

	script.src = src;
	$container.appendChild(script);
}

function wrapTickets(els, event) {
	let wrapper = document.createElement("details");
	wrapper.setAttribute("class", "tito-group");

	let summary = document.createElement("summary");
	summary.setAttribute("class", "tito-group--summary");

	let summaryInner = document.createElement("div");
	summaryInner.setAttribute("class", "tito-group--summary-inner");
	summaryInner.innerHTML =
		"<svg viewBox='0 0 13.59 8.21'><use xlink:href='#icon-arrow-down'></use></svg>";
	summary.appendChild(summaryInner);

	let title = document.createElement("span");
	title.innerText = event.title;
	title.setAttribute("class", "tito-group--summary-title");
	summaryInner.appendChild(title);

	if (event.image) {
		let img = document.createElement("img");
		img.setAttribute("class", "tito-group--summary-img");
		img.src = event.image;
		summaryInner.appendChild(img);
	}

	wrapper.appendChild(summary);

	els[0].parentNode.insertBefore(wrapper, els[0]);

	if (!event.hide_events) {
		// Move all the ticket elemnts from where Tito put them, into our new wrapper
		els.forEach(el => wrapper.appendChild(el));
	} else {
		let message = document.createElement("p");
		message.innerText = event.hidden_message;
		wrapper.appendChild(message);

		// Remove the ticket elements from the page so they don't get listed outside the wrapper we've made
		els.forEach(el => el.remove());
	}
}
